import {useState} from "react";
import { Button, Table } from "react-bootstrap";
import { capitalizeFirst, kopecks2rubStr, replaceStr } from "../../../common/functions";
import IconPayment from "../../../common/assets/icons/payment.png";
import { ITransaction } from "../logics/types";
import "../styles/PaymentListItem.css";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
import { $SiteColors } from "../../../common/config/company-atts";

interface IPaymentListItem {
  kopeikiByMonth: number;
  yyyymm: string;
  transactions: ITransaction[]
}

const titleOptions = {
  year: 'numeric',
  month: 'long'
};
const options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};

export const PaymentListItem = ({ kopeikiByMonth, yyyymm, transactions }: IPaymentListItem) => {
  const [hidePaymentsTable, setHidePaymentsTable] = useState(true);

  function showPaymentsTableClicked() {
    setHidePaymentsTable(!hidePaymentsTable)
  }

  // const dataParser = (yyyymmdataParser: string) => {
  //   const months: any = {
  //     1: "Январь",
  //     2: "Февраль",
  //     3: "Март",
  //     4: "Апрель",
  //     5: "Май",
  //     6: "Июнь",
  //     7: "Июль",
  //     8: "Август",
  //     9: "Сентябрь",
  //     10: "Октябрь",
  //     11: "Ноябрь",
  //     12: "Декабрь"
  // };
  // return months[Number(yyyymmdataParser[4]+yyyymmdataParser[5])] +" "+ yyyymmdataParser.substr(0, 4);
  // }

  // const wordStr = (yyyymmwordStr: string) => {
  //   if (yyyymmwordStr == '') return ''
  //   return dataParser(yyyymmwordStr)
  // }

  const wordStr = (yyyymm: string) => {
    if (yyyymm == '') return ''
    let dt = new Date(replaceStr(yyyymm, '-', 4))
    return capitalizeFirst(dt.toLocaleString('default', { month: 'long' })) + " " + dt.getFullYear()
    //return yyyymm == '' ? "" : capitalizeFirst((new Date(replaceStr(yyyymm, '-', 4))).toLocaleString("ru", titleOptions))
  }

  if (transactions.length == 0) {
    return <></>
  }

  return (
    <li className="m_pli_li">
      <div className="m_pli_li_title_con">
        <img src={IconPayment} className="m_pli_title_img"></img>
        <p className="m_pli_title_period_name">{wordStr(yyyymm)}</p>
        <p className="m_pli_title_period_amount" style={getCustomUserAgent() === getCustomUserAgentASB() ? { margin: 0, color:$SiteColors.getState().chargeTextColor } : { color:$SiteColors.getState().chargeTextColor}}>{kopecks2rubStr(kopeikiByMonth)}</p>
        {getCustomUserAgent() !== getCustomUserAgentASB() ?
          <div className="m_pli_show_table_con">
            <Button onClick={showPaymentsTableClicked} variant="link" size="sm" className="m_pli_show_table_btn">{(hidePaymentsTable ? "Подробнее" : "Скрыть")}</Button>
            <Button hidden={true} onClick={showPaymentsTableClicked} variant="link" size="sm" className="m_pli_show_table_btn">{(hidePaymentsTable ? <ChevronDown /> : <ChevronUp />)}</Button>
          </div>
          : null}
      </div>
      <hr hidden={hidePaymentsTable} className="m_pli_hLine" />
      <div hidden={hidePaymentsTable} className="m_pli_table_con">
        <Table responsive="sm" className="table-borderless" size="sm">
          <tbody>
            {transactions.map((e, i) => (
              <tr key={i}>
                <td className="m_pli_td_month" >{e.date == null ? "" : (new Date(e.date)).toLocaleString("ru",
                  {//@ts-ignore
                    options
                  })}</td>
                <td className="m_pli_table_td_amount" style={{color:$SiteColors.getState().chargeTextColor}}>{kopecks2rubStr(e.amount == "" ? 0 : parseInt(e.amount))}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </li>
  );
};


